(function uiSelectExtendModuleDefinition() {

    'use strict';

    angular.module('ui.selectExtend', [])
        .directive('uiSelectRequired', function () {
        return {
            require: 'ngModel',

            link: function (scope, elm, attrs, ctrl) {
                ctrl.$validators.uiSelectRequired = function (modelValue, viewValue) {

                    var determineVal;
                    if (angular.isArray(modelValue)) {
                        determineVal = modelValue;
                    } else if (angular.isArray(viewValue)) {
                        determineVal = viewValue;
                    } else {
                        return false;
                    }

                    return determineVal.length > 0;
                };
            }

        }
     });

    /*
    Se define para poder filtra objs por ids
    */

    angular.module('ui.selectExtend').filter('propsFilter', function () {
        return function (items, props) {
            var out = [];

            if (angular.isArray(items)) {
                items.forEach(function (item) {
                    var itemMatches = false;

                    var keys = Object.keys(props);
                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var text = props[prop].toLowerCase();
                        if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                            itemMatches = true;
                            break;
                        }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        };
    });
    
})();
